import { Provider, APP_BOOTSTRAP_LISTENER, ComponentRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FbPaidPixelService } from './fbpaid-pixel.service'
import { DvtagPaidPixelService } from './dvgtag-paid-pixels.service'
import { GAdsPaidPixelService } from './gads-paid-pixels.service'
import { environment } from 'src/environments/environment';

export const FACEBOOK_PIXEL_PROVIDER: Provider = {
  provide: APP_BOOTSTRAP_LISTENER,
  multi: true,
  useFactory: FacebookPixelRouterInitializer,
  deps: [
    FbPaidPixelService,
    DvtagPaidPixelService,
    GAdsPaidPixelService,
    Router
  ]
};

export function FacebookPixelRouterInitializer(
  $fpService: FbPaidPixelService,
  $dvService: DvtagPaidPixelService,
  $gadsService: GAdsPaidPixelService,
  $router: Router
) {
  var production = environment.production;
  if (production == "true") {
    return async (c: ComponentRef<any>) => {
      $router
        .events
        .subscribe(event => {
          if (event instanceof NavigationEnd) {
            if (event.url.includes("home")) {

            } else if (event.url.includes("summary")) {
            } else {
              if (document.getElementById("dvgtag")) {
                document.getElementById("dvgtag").remove();
              }
              if (document.getElementById("fb_noscript")) {
                document.getElementById("fb_noscript").remove();
              }

              if (document.getElementById("dc360")) {
                document.getElementById("dc360").remove();
              }
              if (document.getElementById("dvgtag_pixel")) {
                document.getElementById("dvgtag_pixel").remove();
              }
              if (document.getElementById("gads")) {
                document.getElementById("gads").remove();
              }
              if (document.getElementById("gtag_init")) {
                document.getElementById("gtag_init").remove();
              }
              if (document.getElementById("gads-conversion")) {
                document.getElementById("gads-conversion").remove();
              }

            }
          }
        });
    };
  }
}
